import { render, staticRenderFns } from "./findProjectsTab.vue?vue&type=template&id=b4433c52&scoped=true&"
import script from "./findProjectsTab.vue?vue&type=script&lang=js&"
export * from "./findProjectsTab.vue?vue&type=script&lang=js&"
import style0 from "./findProjectsTab.vue?vue&type=style&index=0&id=b4433c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4433c52",
  null
  
)

export default component.exports